/**
 * Статическая карта мест зала ДК: партер и балкон.
 * Перенесено из старой системы (ag_platform_crm) без изменения геометрии,
 * чтобы номера рядов/мест и цветовые категории совпадали с уже проданными билетами.
 */

export const priceColors = {
  300: '#c4cc66',
  400: '#cc66cc',
  500: '#ffcccc',
  600: '#ff9933',
};

const getParterSeatPrice = (rowNumber, seatNumber) => {
  if (rowNumber >= 17 && rowNumber <= 19) return 400;
  if (rowNumber >= 4 && rowNumber <= 6 && seatNumber >= 5 && seatNumber <= 28) return 600;
  if (rowNumber >= 7 && rowNumber <= 9 && seatNumber >= 6 && seatNumber <= 29) return 600;
  if (rowNumber === 10 && seatNumber >= 6 && seatNumber <= 24) return 600;
  if (rowNumber >= 11 && rowNumber <= 14 && seatNumber >= 6 && seatNumber <= 31) return 600;
  return 500;
};

export const seatMapParter = [
  [
    ...Array.from({ length: 14 }, (_, i) => ({
      label: String(i + 1),
      seatNumber: i + 1,
      status: 'available',
      price: getParterSeatPrice(1, i + 1),
    })),
    { label: '', status: 'gap', price: 0 },
    ...Array.from({ length: 14 }, (_, i) => ({
      label: String(i + 15),
      seatNumber: i + 15,
      status: 'available',
      price: getParterSeatPrice(1, i + 15),
    })),
  ],
  ...Array.from({ length: 2 }, (_, rowIdx) => {
    const rowNumber = rowIdx + 2;
    const left = Array.from({ length: 15 }, (_, i) => ({
      label: String(i + 1),
      seatNumber: i + 1,
      status: 'available',
      price: getParterSeatPrice(rowNumber, i + 1),
    }));
    const right = Array.from({ length: 15 }, (_, i) => ({
      label: String(i + 16),
      seatNumber: i + 16,
      status: 'available',
      price: getParterSeatPrice(rowNumber, i + 16),
    }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...right];
  }),
  ...Array.from({ length: 3 }, (_, rowIdx) => {
    const rowNumber = rowIdx + 4;
    const left = Array.from({ length: 16 }, (_, i) => ({
      label: String(i + 1),
      seatNumber: i + 1,
      status: 'available',
      price: getParterSeatPrice(rowNumber, i + 1),
    }));
    const right = Array.from({ length: 16 }, (_, i) => ({
      label: String(i + 17),
      seatNumber: i + 17,
      status: 'available',
      price: getParterSeatPrice(rowNumber, i + 17),
    }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...right];
  }),
  ...Array.from({ length: 3 }, (_, rowIdx) => {
    const rowNumber = rowIdx + 7;
    const left = Array.from({ length: 17 }, (_, i) => ({
      label: String(i + 1),
      seatNumber: i + 1,
      status: 'available',
      price: getParterSeatPrice(rowNumber, i + 1),
    }));
    const right = Array.from({ length: 17 }, (_, i) => ({
      label: String(i + 18),
      seatNumber: i + 18,
      status: 'available',
      price: getParterSeatPrice(rowNumber, i + 18),
    }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...right];
  }),
  (() => {
    const rowNumber = 10;
    const left = Array.from({ length: 17 }, (_, i) => ({
      label: String(i + 1),
      seatNumber: i + 1,
      status: 'available',
      price: getParterSeatPrice(rowNumber, i + 1),
    }));
    const postGap = Array.from({ length: 5 }, () => ({ label: '', status: 'gap', price: 0 }));
    const right = Array.from({ length: 12 }, (_, i) => ({
      label: String(i + 18),
      seatNumber: i + 18,
      status: 'available',
      price: getParterSeatPrice(rowNumber, i + 18),
    }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...postGap, ...right];
  })(),
  Array.from({ length: 36 }, () => ({ label: '', status: 'gap', price: 0 })),
  ...Array.from({ length: 9 }, (_, rowIdx) => {
    const rowNumber = rowIdx + 11;
    return Array.from({ length: 36 }, (_, i) => ({
      label: String(i + 1),
      seatNumber: i + 1,
      status: 'available',
      price: getParterSeatPrice(rowNumber, i + 1),
    }));
  }),
];

export const seatMapBalcony = [
  (() => {
    const left = Array.from({ length: 9 }, (_, i) => ({ label: String(i + 1), seatNumber: i + 1, status: 'available', price: 300 }));
    const center = Array.from({ length: 25 }, (_, i) => ({ label: String(i + 10), seatNumber: i + 10, status: 'available', price: 300 }));
    const right = Array.from({ length: 9 }, (_, i) => ({ label: String(i + 35), seatNumber: i + 35, status: 'available', price: 300 }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...center, { label: '', status: 'gap', price: 0 }, ...right];
  })(),
  (() => {
    const left = Array.from({ length: 9 }, (_, i) => ({ label: String(i + 1), seatNumber: i + 1, status: 'available', price: 300 }));
    const center = Array.from({ length: 25 }, (_, i) => ({ label: String(i + 10), seatNumber: i + 10, status: 'available', price: 300 }));
    const right = Array.from({ length: 9 }, (_, i) => ({ label: String(i + 35), seatNumber: i + 35, status: 'available', price: 300 }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...center, { label: '', status: 'gap', price: 0 }, ...right];
  })(),
  (() => {
    const left = Array.from({ length: 10 }, (_, i) => ({ label: String(i + 1), seatNumber: i + 1, status: 'available', price: 300 }));
    const center = Array.from({ length: 25 }, (_, i) => ({ label: String(i + 11), seatNumber: i + 11, status: 'available', price: 300 }));
    const right = Array.from({ length: 10 }, (_, i) => ({ label: String(i + 36), seatNumber: i + 36, status: 'available', price: 300 }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...center, { label: '', status: 'gap', price: 0 }, ...right];
  })(),
  (() => {
    const left = Array.from({ length: 7 }, (_, i) => ({ label: String(i + 1), seatNumber: i + 1, status: 'available', price: 300 }));
    const centerGaps = Array.from({ length: 25 }, () => ({ label: '', status: 'gap', price: 0 }));
    const right = Array.from({ length: 7 }, (_, i) => ({ label: String(i + 8), seatNumber: i + 8, status: 'available', price: 300 }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...centerGaps, { label: '', status: 'gap', price: 0 }, ...right];
  })(),
  Array.from({ length: 47 }, () => ({ label: '', status: 'gap', price: 0 })),
  (() => {
    const left = Array.from({ length: 12 }, (_, i) => ({ label: String(i + 1), seatNumber: i + 1, status: 'available', price: 300 }));
    const right = Array.from({ length: 21 }, (_, i) => ({ label: String(i + 13), seatNumber: i + 13, status: 'available', price: 300 }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...right];
  })(),
  ...Array.from({ length: 4 }, () => {
    const left = Array.from({ length: 12 }, (_, i) => ({ label: String(i + 1), seatNumber: i + 1, status: 'available', price: 300 }));
    const right = Array.from({ length: 22 }, (_, i) => ({ label: String(i + 13), seatNumber: i + 13, status: 'available', price: 300 }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...right];
  }),
  (() => {
    const left = Array.from({ length: 12 }, (_, i) => ({ label: String(i + 1), seatNumber: i + 1, status: 'available', price: 300 }));
    const middleGaps = Array.from({ length: 8 }, () => ({ label: '', status: 'gap', price: 0 }));
    const right = Array.from({ length: 15 }, (_, i) => ({ label: String(i + 13), seatNumber: i + 13, status: 'available', price: 300 }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...middleGaps, ...right];
  })(),
  (() => {
    const left = Array.from({ length: 14 }, (_, i) => ({ label: String(i + 1), seatNumber: i + 1, status: 'available', price: 300 }));
    const middleGaps = Array.from({ length: 8 }, () => ({ label: '', status: 'gap', price: 0 }));
    const right = Array.from({ length: 17 }, (_, i) => ({ label: String(i + 15), seatNumber: i + 15, status: 'available', price: 300 }));
    return [...left, { label: '', status: 'gap', price: 0 }, ...middleGaps, ...right];
  })(),
];

export const getParterRowNumber = (index) => {
  if (index < 10) return index + 1;
  if (index === 10) return null;
  return index;
};

export const getBalconyRowNumber = (index) => {
  if (index < 4) return index + 1;
  if (index === 4) return null;
  return index;
};
